import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Java = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M6.22042 11.8268C6.22042 11.8268 5.70261 12.1379 6.58941 12.2429C7.6639 12.3696 8.21299 12.3515 9.39676 12.1204C9.39676 12.1204 9.70862 12.3218 10.1433 12.4963C7.4887 13.6705 4.13562 12.4282 6.22042 11.8268ZM5.89585 10.2942C5.89585 10.2942 5.31493 10.7382 6.20249 10.8331C7.35031 10.9555 8.25655 10.9654 9.8255 10.6536C9.8255 10.6536 10.042 10.8808 10.383 11.0048C7.17402 11.9738 3.59989 11.0811 5.89585 10.2942Z"
      fill="currentColor"
    />
    <path
      d="M8.63021 7.69395C9.28467 8.47176 8.45859 9.17105 8.45859 9.17105C8.45859 9.17105 10.1193 8.28602 9.35679 7.17724C8.64433 6.14372 8.09818 5.63038 11.0551 3.85965C11.0551 3.85965 6.41355 5.05636 8.63021 7.69395Z"
      fill="currentColor"
    />
    <path
      d="M12.141 12.9606C12.141 12.9606 12.5243 13.287 11.7187 13.5392C10.1869 14.0183 5.34187 14.1628 3.99625 13.5584C3.51277 13.341 4.41977 13.0397 4.70513 12.9761C5.00264 12.9096 5.17253 12.9217 5.17253 12.9217C4.63452 12.5306 1.69519 13.6899 3.67973 14.0225C9.09143 14.9283 13.5445 13.6146 12.141 12.9606ZM6.4697 8.70594C6.4697 8.70594 4.00549 9.31035 5.59714 9.53006C6.2693 9.62293 7.60861 9.60162 8.85702 9.4935C9.87699 9.40501 10.9005 9.21603 10.9005 9.21603C10.9005 9.21603 10.5412 9.37518 10.281 9.55844C7.77807 10.2382 2.94413 9.9216 4.33592 9.22668C5.51252 8.63909 6.4697 8.70594 6.4697 8.70594ZM10.8903 11.2572C13.4344 9.89255 12.258 8.58111 11.4369 8.75775C11.2362 8.80093 11.1461 8.83851 11.1461 8.83851C11.1461 8.83851 11.2209 8.71749 11.3634 8.66545C12.9876 8.07607 14.2366 10.4042 10.8395 11.3264C10.8395 11.3261 10.8785 11.2897 10.8903 11.2572Z"
      fill="currentColor"
    />
    <path
      d="M9.35679 1C9.35679 1 10.7654 2.45534 8.0204 4.69253C5.81905 6.48771 7.51846 7.51102 8.01964 8.6807C6.73453 7.48366 5.7919 6.42972 6.42419 5.44891C7.3527 4.0095 9.925 3.31132 9.35679 1Z"
      fill="currentColor"
    />
    <path
      d="M6.71975 14.9561C9.16116 15.1173 12.9113 14.8664 13 13.6735C13 13.6735 12.8294 14.1257 10.9821 14.4845C8.89808 14.8896 6.32719 14.8424 4.80289 14.5825C4.80289 14.5825 5.11518 14.8495 6.71975 14.9561Z"
      fill="currentColor"
    />
  </Icon>
));

export default Java;
